exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".gh-button-email[data-v-3a13b266]{text-decoration:none;display:inline-block}", ""]);

// exports
